import {apiGet} from './index';

export const SEGMENTATION_CALC_TYPES = [
    'volume',
    'net_revenue',
    'variable_margin',
    'variable_margin_per_unit',
    'variable_margin_percent',
    'pocket_price_margin',
    'pocket_price_margin_per_unit',
    'pocket_price_margin_percent',
];

export const SEGMENTATION_CALC_COLUMN_LABELS = {
    volume: 'Volume',
    net_revenue: 'Net Revenue',
    variable_margin: 'VM',
    variable_margin_per_unit: 'VM/Unit',
    variable_margin_percent: 'VM%',
    pocket_price_margin: 'PPM',
    pocket_price_margin_per_unit: 'PPM/Unit',
    pocket_price_margin_percent: 'PPM%',
};

export const SEGMENTATION_BY_FROM_VIEW = {
    customers: 'account',
    products: 'product',
    sales_reps: 'sales_reps',
};

const GROUP_BY_QUERY_PARAM = {
    account: 'account',
    product: 'product',
    sales_reps: 'sales_person',
};

export const fetchSegmentationByVMAndVolume = (queryParams, segmentationBy, callback) => {
    const groupBy = GROUP_BY_QUERY_PARAM[segmentationBy] || 'account';
    const separator = queryParams.includes('?') ? '&' : '?';
    apiGet(
        `v2/segmentation/by_vm_and_volume${queryParams}${separator}group_by=${groupBy}`,
        (resp) => callback(resp?.success ? resp.data : null)
    );
};

export const mapCalcBreakdownToSegmentationRows = (breakdown = [], calcTypes = SEGMENTATION_CALC_TYPES) => (
    breakdown.map((row) => {
        const mapped = {
            id: row.id,
            name: row.name,
            number: row.number ?? null,
            hierarchy_names: row.hierarchy_names ?? null,
            segment: null,
        };
        for (const type of calcTypes) {
            mapped[type] = row[type]?.current ?? row[type] ?? 0;
        }
        return mapped;
    })
);
